import ModulesHelper from '@core/services/modules.helper';

const routes = [
  {
    path: 'mailbox',
    name: 'admin-mailbox',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      module: ModulesHelper.COMMUNICATIONS_MODULE_NAME,
    },
    component: () =>
      import(/* webpackChunkName: "admin-mailbox" */ '@communications/pages/mailbox/mailbox.vue'),
  },
];

export const communicationsAdminRoutes = [
  {
    path: 'club-messages',
    name: 'admin-club-messages',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      module: ModulesHelper.COMMUNICATIONS_MODULE_NAME,
    },
    component: () =>
      import(
        /* webpackChunkName: "admin-club-messages" */ '@communications/pages/mailbox/mailbox.vue'
      ),
  },
];

export default routes;
